import classnames from 'classnames';
import { ContentUnderTopAppBar, TopAppBar } from '@llt-frontend/react-material-top-app-bar';
import PropTypes from 'prop-types';
import React from 'react';

import logoSvg from '@llt-frontend/brands/varsity-tutors/e.svg';

// Internal
// --------

function StaticLayout({ children, isMobileApp = false }) {
  return (
    <>
      {!isMobileApp && (
        <TopAppBar className="site-header">
          <a href="/">
            <img alt="Varsity Tutors" className="mdc-top-app-bar__site-logo" src={logoSvg} />
            Varsity Tutors
          </a>
        </TopAppBar>
      )}

      <ContentUnderTopAppBar
        className={classnames('main', { 'main--mobile': isMobileApp })}
        component="main"
        role="main"
      >
        <div className="main-content">{children}</div>
      </ContentUnderTopAppBar>
    </>
  );
}

StaticLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

// Exports
// -------

export default StaticLayout;
